export default class prioridad{
    constructor($scope,
                $routeParams,
                method,
                prioridadesService,
                $location,
                $uibModal,
                toastr
    ){
        this.scope    = $scope;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(prioridadesService);
                break;
            case 'new':
                this.create(prioridadesService);
                break;
            case 'view':
                this.view($routeParams,
                    prioridadesService);
                break;
        }
    }

    list(prioridadesService){

        let self = this.scope;

        prioridadesService.getAll().then((resp, err) => {
            self.prioridades = resp.data.message;
        });

        self.getItemPage = (item) => {
            let index = self.prioridades.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, prioridadesService);

        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                prioridadesService.delete({_id: id}).then((resp) => {
                    this.toastr.success('Prioridad eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
                .catch((err) => {
                    this.toastr.error('Error', 'Error al eliminar prioridad!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };*/
    }

    create(prioridadesService){

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                prioridadesService.save(this.scope.prioridad).then((resp) => {
                    this.toastr.success('Prioridad creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/prioridad');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear la prioridad!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    view($routeParams,
         prioridadesService){

        this.scope.aux = {};
        prioridadesService.getById({_id: $routeParams.id}).then((resp) => {
            this.scope.prioridad = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                prioridadesService.update(this.scope.prioridad).then((resp) => {
                    this.toastr.success('Prioridad modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/prioridad');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar la prioridad!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Prioridad</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la prioridad: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.prioridades.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Prioridad eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar la prioridad!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/prioridad/prioridad.js